module.exports = __webpack_public_path__ + "static/media/11-rectangle-occupied.d6724e38.svg";